import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgShow = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M23.499 12.208C21.107 7.17 17.49 4.634 12.644 4.634c-4.849 0-8.462 2.536-10.854 7.577a1.521 1.521 0 0 0 0 1.3c2.392 5.038 6.008 7.574 10.854 7.574 4.85 0 8.463-2.536 10.855-7.577a1.521 1.521 0 0 0 0-1.3Zm-10.855 7.06c-4.07 0-7.05-2.064-9.15-6.409 2.1-4.344 5.08-6.408 9.15-6.408s7.05 2.064 9.152 6.408c-2.1 4.345-5.08 6.409-9.152 6.409Zm-.1-10.85a4.44 4.44 0 1 0 0 8.882 4.44 4.44 0 0 0 0-8.881Zm0 7.267a2.824 2.824 0 0 1-2.826-2.826 2.824 2.824 0 0 1 2.825-2.825 2.824 2.824 0 0 1 2.826 2.825 2.824 2.824 0 0 1-2.826 2.826Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgShow)
const Memo = memo(ForwardRef)
export default Memo
